import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_URL = process.env.REACT_APP_API_URL ;

// GET all skip EMI records
export const fetchSkipEmi = createAsyncThunk('skipEmi/fetchAll', async (_, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/get-skip-emi`);
    const data = await res.json();
    return data.skipDays || [];
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// PUT: set skip EMI (e.g. {"day": "Monday", "status": false})
export const setSkipEmi = createAsyncThunk('skipEmi/set', async (payload, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/set-skip-emi`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return data.skipDay;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// PUT: update skip EMI by ID
export const updateSkipEmi = createAsyncThunk('skipEmi/update', async ({ id, day, status }, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/update-skip-emi/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ day, status }),
    });
    const data = await res.json();
    return data.skipDay;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const skipEmiSlice = createSlice({
  name: 'skipEmi',
  initialState: {
    days: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSkipEmi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSkipEmi.fulfilled, (state, action) => {
        state.loading = false;
        state.days = action.payload;
      })
      .addCase(fetchSkipEmi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(setSkipEmi.fulfilled, (state, action) => {
        state.days.push(action.payload);
      })
      .addCase(updateSkipEmi.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.days.findIndex((d) => d.id === updated.id);
        if (index !== -1) {
          state.days[index] = updated;
        }
      });
  },
});

export default skipEmiSlice.reducer;
